export function isTauri() { return false; }

export default {};
